export { AmplitudeCreator } from './amplitude.creator';
export { AMPLITUDE_DEFAULTS, type AmplitudeParams } from './amplitude.model';
